import { render, staticRenderFns } from "./BusinessPartnerTypeForm.vue?vue&type=template&id=0f7d9ac6&"
import script from "./BusinessPartnerTypeForm.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerTypeForm.vue?vue&type=style&index=0&id=0f7d9ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports